import React from 'react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'
import Img from 'gatsby-image'

const Post = styled.li`
  position: relative;
  border: 1px solid ${props => props.theme.colors.secondary};
  border-radius: 2px;
  margin: 0 0 1em 0;
  width: 100%;
  transition: background 0.2s;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    flex: ${props => (props.featured ? '0 0 100%' : '0 0 49%')};
    margin: 0 0 2vw 0;
  }
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    flex: ${props => (props.featured ? '0 0 100%' : '0 0 32%')};
  }
  &:hover {
    background: ${props => props.theme.colors.tertiary};
  }
  a {
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
    color: ${props => props.theme.colors.text};
    text-decoration: none;
    .gatsby-image-wrapper {
      height: 0;
      padding-bottom: 60%;
      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        padding-bottom: ${props => (props.featured ? '40%' : '60%')};
      }
    }
  }
`

const StyledImg = styled(Img)`
  border-top-left-radius: 1px;
  border-top-right-radius: 1px;
`

const Title = styled.h2`
  font-size: 1.5em;
  font-weight: 600;
  text-transform: capitalize;
  margin: 1rem 1rem 0.5rem 1rem;
`

const Date = styled.h3`
  margin: 0 1rem 0.5rem 1rem;
  color: gray;
`

const ReadingTime = styled.h4`
  margin: 0 1rem 1.5rem 1rem;
  color: gray;
`

const Excerpt = styled.p`
  font-size: 0.9em;
`

const Card = ({ slug, heroImage, title, publishDate, body, ...props }) => {
  return (
    <>
      {heroImage && body && (
        <div className="masonry-grid-item col-sm-6 col-lg-4 g-mb-30" style={{position: 'absolute', left: '0%', top: 0}}>
          {/* Blog Classic Blocks */}
          <article className="u-shadow-v11">
            <Link to={`${props.basePath}/${slug}/`}>
              <StyledImg fluid={heroImage.fluid} backgroundColor={'#eeeeee'} />
            </Link>
            <div className="g-bg-white g-pa-30">
              <span className="d-block g-color-gray-dark-v4 g-font-weight-600 g-font-size-12 mb-2">{publishDate}</span>
              <h2 className="h5 g-color-black g-font-weight-600 mb-3">
              <Link to={`${props.basePath}/${slug}/`}>{title}</Link>
              </h2>
              <p className="g-color-gray-dark-v4 g-line-height-1_8">
                <Excerpt
                  dangerouslySetInnerHTML={{
                    __html: body.childMarkdownRemark.excerpt,
                  }}
                />
              </p>
              <Link to={`${props.basePath}/${slug}/`}>Read more...</Link>
              <hr className="g-my-20" />
              <ul className="list-inline d-flex justify-content-between mb-0">
                <li className="list-inline-item g-color-gray-dark-v4">
                  <a className="d-inline-block g-color-gray-dark-v4 g-font-size-13 g-cursor-pointer g-text-underline--none--hover" href="#">
                    <i className="align-middle g-font-size-default mr-1 icon-electronics-029 u-line-icon-pro" />
                    {body.childMarkdownRemark.timeToRead} min read
                  </a>
                </li>
                {/*<li className="list-inline-item g-color-gray-dark-v4">
                  <i className="align-middle g-color-primary g-font-size-default mr-1 icon-medical-022 u-line-icon-pro" />
                  <a className="d-inline-block g-color-gray-dark-v4 g-font-size-13 g-cursor-pointer g-text-underline--none--hover" href="#">57</a>
                </li>*/}
              </ul>
            </div>
          </article>
          {/* End Blog Classic Blocks */}
          {/* 
          {heroImage && body && (
            <Post featured={props.featured}>
              <Link to={`${props.basePath}/${slug}/`}>
                <StyledImg fluid={heroImage.fluid} backgroundColor={'#eeeeee'} />
                <Title>{title}</Title>
                <Date>{publishDate}</Date>
                <ReadingTime>
                  {body.childMarkdownRemark.timeToRead} min read
                </ReadingTime>
                <Excerpt
                  dangerouslySetInnerHTML={{
                    __html: body.childMarkdownRemark.excerpt,
                  }}
                />
              </Link>
            </Post>
          )}
          */}
        </div>
      )}
    </>
  )
}

export default Card
